import axios from "axios";

const url = process.env.REACT_APP_API_URL;

export const get = (task_id) => axios.get(url + `/api/tasks/${task_id}/comments`);
export const post = (task_id, data) => axios.post(url + `/api/tasks/${task_id}/comments`, data);
export const del = (task_id, id) => axios.delete(url + `/api/tasks/${task_id}/comments/${id}`);
